import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
const Mask = ({ className, visible = true, transparent = false, children, onClick }) => {
    if (!visible) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: classNames('taro-mask', className) }, { children: [_jsx("div", { className: classNames({
                    'taro-mask_button': !transparent,
                    'taro-mask_button-transparent': transparent
                }), onClick: onClick }), children] })));
};
export default Mask;
